// Import model
import { ContactAssignmentCondition } from '../models/ContactAssignmentCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ContactAssignmentIndexedFields } from '../models/ContactAssignmentIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ContactAssignmentIndexedFieldsSerializer } from './ContactAssignmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ContactAssignmentCondition - handles JSON serialization and deserialization with type validation
 */
export class ContactAssignmentConditionSerializer {
  /**
   * Deserializes a JSON string into a ContactAssignmentCondition instance
   */
  static deserialize(json: string): ContactAssignmentCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ContactAssignmentCondition instance
   */
  static fromObject(obj: any): ContactAssignmentCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ContactAssignmentCondition');
    }


    const instance: ContactAssignmentCondition = {
      fieldName: obj['fieldName'] as ContactAssignmentIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ContactAssignmentCondition instances
   */
  static deserializeArray(json: string): ContactAssignmentCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ContactAssignmentCondition instance to a JSON string
   */
  static serialize(instance: ContactAssignmentCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ContactAssignmentCondition instance to a plain object
   */
  static toObject(instance: ContactAssignmentCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ContactAssignmentCondition instances to a JSON string
   */
  static serializeArray(instances: ContactAssignmentCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
